/**
 * /prompt-generator — сборка страницы.
 *
 * ── Что тут решается (замеры, не вкусовщина) ────────────────────────────────
 *
 * 1. ФОРМА ОТСЕКАЛА ТЕХ, КТО ПРИШЁЛ. Первая версия (08-21, утро) встречала
 *    девятью пустыми полями. Наши же тулы за 60 дней говорят обратное — готовое
 *    выбирают в разы чаще, чем заполняют поля:
 *      /song-generator  style_pick 2090 сессий · custom_style 414  (x5.0)
 *      /sfx-generator   preset      156        · generate      23  (x6.8)
 *      /music-generator style_pick  193        · custom_style 123  (x1.6)
 *    Отсюда вход в ОДНО поле и готовые промты, которые приходят к человеку сами.
 *
 * 2. ТРИ ВКЛАДКИ БЫЛИ ТРЕМЯ КОПИЯМИ (перестройка 08-24). «Конструктор»,
 *    «Разбор промта» и «Готовые промты» держали в разметке два кольца оценки,
 *    две кнопки «Усилить», два блока «пустых слов» и два пути разбора. Кнопка
 *    «Открыть в конструкторе» на второй вкладке — это признание, что первая и
 *    вторая суть одно действие с разных входов. Теперь вход один: короткая
 *    мысль собирается, вставленный промт разбирается, дальше они неразличимы.
 *    «Разбор» перестал быть местом и стал показанием прибора справа.
 *
 * 3. ХОЛСТ И «ТЕКСТ ПРОМТА» ПОКАЗЫВАЛИ ОДНО И ТО ЖЕ. Два блока друг под другом
 *    с одинаковым содержимым — полтора экрана на одну строку. Стало: одна
 *    область и переключатель вида (по частям · текст · English).
 *
 * 4. ПОМОЩЬ ДОСТАВАЛАСЬ ТЕМ, КОМУ НЕ НУЖНА. Корневой замер /sfx-generator:
 *    11 коротких промтов из 11 упёрлись в платный шлагбаум, 6 длинных из 6
 *    прошли. Сборку и разбор мы сделали браузерными сразу; с Chrome 148
 *    браузерной становится и модель — см. ondevice.js. Токены остаются только
 *    там, где за ними чужая машина.
 *
 * 5. БИБЛИОТЕКА БЫЛА В ЯЩИКЕ, И ЕЁ НЕ НАХОДИЛИ (перестройка 08-26). Замер
 *    24–26.08 на RU: 49 сессий, ящик открыли 4, взяли из него один промт —
 *    при спросе «промты для фото» 70 479/мес, вдвое больше, чем у «создание
 *    промта». 13 из 16 сборок были про картинку, а список «Тип промта» молча
 *    стоял на «Текст и чат», и подборка справа показывала портреты: три органа
 *    страницы говорили о разном. Теперь тип промта — ОДНА ось (ряд сверху):
 *    по ней собирает конструктор и по ней же фильтруется библиотека, которая
 *    стоит на странице; фраза в поле подбирает карточки ещё до «Собрать».
 *
 * Вид промта (картинка / текст / музыка / видео / код) определяется по фразе,
 * а не спрашивается: вопрос до результата — тот же барьер, только меньше.
 */
import { analyze, analyzeValues, detectKind, nextBestSlot, grade } from './analyze.js';
import { buildPrompt, buildMusicPrompt, ORDER, fillVars, varsOf } from './build.js';
import { safeSplit } from './split.js';

/** Текст уже начинается с запрета — второй приставки ему не нужно. */
const ALREADY_NEGATED = /^(?:no|without|avoid)\b|^not\s|^без\s|^не\s|^никаких\s|^исключ/i;
import { probeModel, improveOnDevice, runOnDevice, probeTranslator, toEnglish } from './ondevice.js';

const CFG = window.__PL_CFG || {};
const T = CFG.i18n || {};
const $ = (id) => document.getElementById(id);
const el = (tag, cls, txt) => {
  const n = document.createElement(tag);
  if (cls) n.className = cls;
  if (txt != null) n.textContent = txt;
  return n;
};
/**
 * Подстановка `:имя` в строку перевода.
 *
 * ⚠️ Ключи подставляются от ДЛИННОГО к короткому. Иначе `:n` съедает начало
 * `:need` в «Нужно :need ток., на балансе :bal» и на экран уезжает число
 * вперемешку с обломком плейсхолдера. Порядок объявления полей объекта тут
 * защитой не является: он держится только до первой правки строки.
 */
const fill = (tpl, map) => Object.keys(map)
  .sort((a, b) => b.length - a.length)
  .reduce((s, k) => s.split(':' + k).join(String(map[k])), String(tpl || ''));

/* ── Состояние ───────────────────────────────────────────────────────────── */
const state = {
  started: false,
  kind: 'text',
  model: '',
  values: {},      // slotKey -> string
  byKind: {},      // ввод по видам: смена вида не теряет работу
  built: '',
  /**
   * Музыка — два поля Suno/Udio: строка стиля и каркас текста с тегами секций
   * (music.js). `built` держит склейку (её видят оценка и лейны), а вид
   * «Текст» показывает поля по отдельности, каждое со своим «Скопировать» —
   * человек несёт их в два разных окна Suno.
   */
  music: { style: '', lyrics: '' },
  /**
   * Промт ПРИШЁЛ готовым (вставили целиком), а не собран нами по частям.
   * Разница не косметическая: про собранный промт мы знаем структуру ТОЧНО,
   * про вставленный — не знаем ничего, и там приходится спрашивать словарь.
   * Мешать одно с другим нельзя, это уже ломалось: словарь засчитывал ПУСТОЙ
   * «Контекст» из слова «нашего» в задаче и не засчитывал заполненную «Роль».
   */
  foreign: false,
  /**
   * Человек САМ выбрал вид до нажатия «Собрать».
   *
   * ⚠️ Без этого флага список видов был бы контролом, чьё значение ничего не
   * значит: он показывает «Музыка», а определение по фразе всё равно ставит
   * «Текст», и запускается не то, что выбрано. Ровно этот класс дефекта уже
   * стоил нам разбора #1482 на другом туле — правило оттуда: значение контрола
   * обязано быть тем, что действительно запустится.
   */
  kindPinned: false,
  view: 'parts',   // parts | text | en
  english: '',     // перевод текущего built — считается один раз на текст
  englishOf: '',
  improved: '',
  improvedSrc: '', // device | cloud — чей это результат
  editing: null,
  busy: false,
};

/** Браузерная модель: что показала проба и не сломалась ли она по дороге. */
const device = { model: 'unknown', lang: 'unknown', broken: false, translator: 'unknown' };

const targetOf = (kind) => Object.keys(CFG.targets).find((t) => CFG.targets[t].kind === kind) || 'chat';
const slotText = (key) => (CFG.slotText || {})[key] || {};
const slotLabel = (key) => slotText(key).label || key;
const isMedia = (kind) => ['image', 'video', 'music'].includes(kind);

function ae(action, extra) {
  try { if (window.__aeFeature) window.__aeFeature(action, extra || {}); } catch { /* телеметрия не ломает тул */ }
}

/* ── Вход ────────────────────────────────────────────────────────────────── */
function initStart() {
  const seed = $('pg-seed');
  const go = $('pg-go');
  if (!seed || !go) return;

  const start = () => {
    const v = seed.value.trim();
    if (v.length < (CFG.minChars || 3)) { seed.focus(); return; }
    beginFrom(v);
  };
  go.addEventListener('click', start);
  seed.addEventListener('keydown', (e) => {
    // Enter запускает, Shift+Enter переносит строку — как в любом поле запроса.
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); start(); }
  });

  document.querySelectorAll('[data-seed]').forEach((b) => {
    b.addEventListener('click', () => {
      seed.value = b.dataset.seed;
      ae('seed_example', { seed: b.dataset.seed });
      start();
    });
  });
}

/**
 * Одно поле — два намерения, и различить их надо БЕЗ вопроса человеку.
 *
 * Признак «это уже промт, а не мысль» — не длина сама по себе, а плотность
 * ремесла: если словарь находит в тексте три и больше смысловых частей, это
 * написанный промт, каким бы коротким он ни был. Длина оставлена вторым
 * признаком для промтов, чей словарь мы не покрываем (чужой язык, жаргон).
 */
function beginFrom(text) {
  const det = detectKind(text);
  // Выбор человека сильнее определения по фразе: иначе список видов показывал
  // бы одно, а запускалось бы другое.
  const kind = state.kindPinned ? state.kind : det.kind;
  const probe = analyze(text, kind);
  const present = Object.keys(probe.slots).filter((k) => probe.slots[k].present).length;
  const foreign = present >= 3 || text.length >= 140;

  // Вставленный промт РАЗБИРАЕМ на части, а не кладём целиком в одну.
  //
  // Заявка NE_NAGIEV (#5240, 24.08): «переключаю кнопку по частям и потом
  // текст — меняется только шрифт промта и всё». Он был прав: замер 25.08 на
  // его же промте дал на холсте ОДИН сегмент длиной 323 знака, потому что
  // здесь стояло `{ [required]: text }`. Название вида обещало разбор,
  // которого не было, и отредактировать отдельную часть было нельзя.
  //
  // `safeSplit` при любом сомнении возвращает прежнее поведение: потерять
  // кусок чужого промта хуже, чем не разобрать его.
  openWorkbench(kind, safeSplit(text, kind), !state.kindPinned && !det.confident, foreign);
  ae('start', { kind, pinned: state.kindPinned, guess: det.kind, confident: det.confident, chars: text.length, foreign });
}

/** Единственная дверь в верстак — чтобы состояния не разошлись по копиям. */
function openWorkbench(kind, values, unsure, foreign) {
  const paint = () => {
    state.kind = kind;
    state.model = '';
    state.values = { ...(state.byKind[kind] || {}), ...values };
    state.started = true;
    state.editing = null;
    state.foreign = !!foreign;
    state.view = 'parts';
    state.english = ''; state.englishOf = '';

    const start = $('pg-start');
    const work = $('pg-work');
    const acts = $('pg-acts');
    const bar = $('pg-bar');
    const main = $('pg-main');
    if (start) start.hidden = true;
    if (work) work.hidden = false;
    if (acts) acts.hidden = false;
    if (bar) bar.hidden = false;
    if (main) main.classList.remove('is-idle');
    closeEditor(true);
    syncKindTabs(!!unsure);
    renderModels();
    renderViews();
    refresh();
    // Библиотека ниже следует за видом верстака — та же ось.
    libKind = kind; libCat = ''; libOpen = null; libLimit = LIB_PAGE;
    renderLibrary();
  };

  // Переход между двумя состояниями одной области — ровно тот случай, для
  // которого сделаны переходы вида. Где их нет, просто перерисовываем.
  if (window.__viewTransition) { window.__viewTransition(paint); return; }
  paint();
}

function restart() {
  state.started = false;
  state.editing = null;
  state.improved = '';
  // Заявка на вид живёт ровно один промт. Пережившая «Начать заново», она
  // превратила бы разовый выбор «Музыка» в вечный: следующая фраза «фото на
  // день рождения» собралась бы как музыкальный промт.
  state.kindPinned = false;
  const start = $('pg-start');
  const work = $('pg-work');
  const acts = $('pg-acts');
  const bar = $('pg-bar');
  const main = $('pg-main');
  const out = $('pg-out');
  if (start) start.hidden = false;
  if (work) work.hidden = true;
  if (acts) acts.hidden = true;
  if (bar) bar.hidden = true;
  if (main) main.classList.add('is-idle');
  if (out) out.hidden = true;
  const meter = $('pg-meter');
  if (meter) meter.hidden = true;
  const vague = $('pg-vague');
  if (vague) vague.hidden = true;
  const seed = $('pg-seed');
  if (seed) { seed.value = ''; seed.focus({ preventScroll: true }); }
  syncKindTabs(false);
  renderPicks();
  libKind = ''; libCat = ''; libQuery = ''; libOpen = null; libLimit = LIB_PAGE;
  renderLibrary();
  ae('restart', {});
}

/* ── Тип промта — сегментный ряд, одна ось на всё ───────────────────────── */
/*
 * Порядок — по спросу (Wordstat 08-21): фото 70 479, чат 22 183 + gpt 16 872,
 * видео 8 645, дальше музыка и код. Первая кнопка «Все» — пустое значение:
 * вид определяется по фразе, библиотека ниже без фильтра.
 *
 * Значение ряда — это и то, что ЗАПУСТИТСЯ (kindPinned), и то, что ПОКАЗАНО
 * ниже в библиотеке. Раньше здесь стоял выпадающий список с молчаливым
 * «Текст и чат» по умолчанию, а подборка справа показывала портреты: 13 из
 * 16 сборок на проде были про картинку, и три органа страницы говорили о
 * разном.
 */
const KIND_ORDER = ['image', 'text', 'video', 'music', 'code'];

function initKindTabs() {
  const row = $('pg-kind-row');
  if (!row) return;
  const mk = (kind, label) => {
    const b = el('button', 'pg-kind', label);
    b.type = 'button';
    b.dataset.kind = kind;
    b.addEventListener('click', () => pickKind(kind));
    row.appendChild(b);
  };
  mk('', T.lib_all || '');
  KIND_ORDER
    .filter((k) => Object.keys(CFG.targets).some((t) => CFG.targets[t].kind === k))
    .forEach((k) => mk(k, `${CFG.kindIcons[k] || ''} ${T['target_' + targetOf(k)] || k}`.trim()));
  syncKindTabs(false);
}

function pickKind(k) {
  // До первого «Собрать» ряд — это ЗАЯВКА, а не смена вида: открывать верстак
  // не на чем, там ещё пусто. Но библиотека ниже уже отвечает.
  if (!state.started) {
    state.kindPinned = k !== '';
    if (k) state.kind = k;
    syncKindTabs(false);
    renderModels();
    libKind = k; libCat = ''; libOpen = null; libLimit = LIB_PAGE;
    renderLibrary();
    ae('kind_pick', { kind: k || 'all' });
    return;
  }
  if (!k || k === state.kind) return;
  state.kindPinned = true;
  state.byKind[state.kind] = { ...state.values };
  // Главное поле переносим между видами: человек написал его один раз.
  const carry = state.values[CFG.required[state.kind]] || '';
  const next = { ...(state.byKind[k] || {}) };
  if (carry && !next[CFG.required[k]]) next[CFG.required[k]] = carry;
  openWorkbench(k, next, false, state.foreign);
  ae('kind_change', { kind: k });
}

/** @param {boolean} unsure вид взят умолчанием — просим поправить, не угадываем. */
function syncKindTabs(unsure) {
  const box = $('pg-kind');
  if (!box) return;
  // До первого промта «Все» значит «определить по фразе»; в верстаке вид уже
  // есть, и «Все» там нечего значить — кнопка убирается.
  const value = state.started || state.kindPinned ? state.kind : '';
  box.dataset.value = value;
  box.classList.toggle('is-unsure', !!unsure);
  box.querySelectorAll('.pg-kind').forEach((b) => {
    const on = b.dataset.kind === value;
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (b.dataset.kind === '') b.hidden = state.started;
  });
  const note = $('pg-note');
  if (note && unsure) {
    note.textContent = fill(T.kind_guess, { kind: T['target_' + targetOf(state.kind)] || state.kind });
    note.hidden = false;
  }
}

function renderModels() {
  const sel = $('pg-model');
  if (!sel) return;
  sel.textContent = '';
  const models = (CFG.targets[targetOf(state.kind)] || {}).models || [];
  const any = document.createElement('option');
  any.value = '';
  any.textContent = T.model_any || '—';
  sel.appendChild(any);
  models.forEach((m) => {
    const o = document.createElement('option');
    o.value = m;
    o.textContent = CFG.modelLabels[m] || m;
    sel.appendChild(o);
  });
  sel.value = state.model;
  if (!sel.dataset.bound) {
    sel.dataset.bound = '1';
    sel.addEventListener('change', () => {
      state.model = sel.value;
      state.english = '';
      renderModelNote();
      refresh();
      ae('model', { model: sel.value });
    });
  }
  renderModelNote();
}

/**
 * Флаги --ar/--no понимает одна Midjourney, у остальных они попадают В КАРТИНКУ
 * текстом. Человек должен узнать это ДО нажатия, а не после.
 */
function renderModelNote() {
  const box = $('pg-note');
  if (!box) return;
  const notes = [];
  if (state.kind === 'image' && state.model) {
    const flagged = (CFG.targets.image || {}).flag_syntax || [];
    notes.push(flagged.includes(state.model) ? T.model_note_flags : T.model_note_noflags);
  }
  if (state.kind === 'music') {
    // Стиль собран по-английски из фишек (значение фишки английское), секции
    // ушли тегами в поле текста. Свои слова человека остаются как написаны —
    // и, если они не латиницей, это называется ЗДЕСЬ, до копирования: замер
    // 06.09 на живом Suno — тональность по русскому стилю 1 из 12.
    notes.push(T.music_note || '');
    const foreignWords = nonLatinParts(state.music.style);
    if (foreignWords.length) notes.push(fill(T.music_nonlatin || '', { words: foreignWords.map((w) => `«${w}»`).join(', ') }));
    if (device.translator === 'available') notes.push(T.en_note);
  } else if (isMedia(state.kind)) {
    notes.push(device.translator === 'available' ? T.en_note : T.model_note_english);
  }
  box.textContent = notes.filter(Boolean).join(' ');
  box.hidden = notes.length === 0;
}

/** Части строки стиля, написанные не латиницей (свои слова человека). */
function nonLatinParts(style) {
  return String(style || '').split(/\s*,\s*/)
    .map((s) => s.trim())
    .filter((s) => s && /\p{L}/u.test(s) && !/^[\p{Script=Latin}\p{N}\p{P}\p{S}\s]+$/u.test(s))
    .slice(0, 4);
}

/* ── Виды одного промта ──────────────────────────────────────────────────── */
/*
 * «По частям», «Текст» и «English» — три ВИДИМОСТИ одного промта, а не три
 * блока друг под другом. Раньше холст и «Текст промта» стояли стопкой и
 * показывали одно и то же; английский вариант вообще существовал только внутри
 * платного усиления, то есть за перевод человек платил токенами.
 */
function initViews() {
  document.querySelectorAll('[data-view]').forEach((b) => {
    b.addEventListener('click', () => setView(b.dataset.view));
  });
}

function setView(v) {
  state.view = v;
  renderViews();
  if (v === 'en') makeEnglish();
  ae('view', { view: v });
}

function renderViews() {
  document.querySelectorAll('[data-view]').forEach((b) => {
    const on = b.dataset.view === state.view;
    b.classList.toggle('is-on', on);
    // Подсветка — единственный признак выбранного вида; скринридеру она не
    // видна, поэтому состояние объявляется отдельно.
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  const enBtn = $('pg-view-en');
  // Английский вид предлагаем только там, где он ЗАМЕРЕННО меняет результат:
  // у чата и кода ответ приходит на языке промта, и перевод там был бы вреден.
  if (enBtn) enBtn.hidden = !(isMedia(state.kind) && device.translator === 'available' && CFG.lang !== 'en');
  if (state.view === 'en' && enBtn && enBtn.hidden) state.view = 'parts';

  const canvas = $('pg-canvas');
  const plain = $('pg-plain');
  const musicBox = $('pg-plain-music');
  // Вид «Текст» у музыки — два поля с ОТДЕЛЬНЫМИ кнопками копирования: Suno и
  // Udio держат стиль и текст в разных окнах, и одна склейка заставляла бы
  // человека резать её руками. Вид «English» остаётся общим полем: там перевод.
  const musicText = state.kind === 'music' && state.view === 'text';
  if (canvas) canvas.hidden = state.view !== 'parts';
  if (plain) plain.hidden = state.view === 'parts' || musicText;
  if (musicBox) musicBox.hidden = !musicText;
  if (plain && state.view === 'text' && !musicText) { plain.textContent = state.built; plain.classList.remove('is-busy'); }
  if (musicText) renderMusicFields();
}

/** Два поля Suno в виде «Текст»: стиль и каркас текста. */
function renderMusicFields() {
  const st = $('pg-music-style');
  const ly = $('pg-music-lyrics');
  const lyBox = $('pg-music-lyrics-box');
  if (st) st.textContent = state.music.style;
  if (ly) ly.textContent = state.music.lyrics;
  // Без структуры второго поля нет — и заголовок «Текст песни» над пустым
  // окном был бы обещанием, которого промт не несёт.
  if (lyBox) lyBox.hidden = !state.music.lyrics;
}

/** Перевод считается один раз на текст: переключение туда-обратно бесплатно. */
async function makeEnglish() {
  const plain = $('pg-plain');
  if (!plain) return;
  if (state.englishOf === state.built && state.english) { plain.textContent = state.english; return; }
  plain.classList.add('is-busy');
  plain.textContent = T.en_making || '…';
  try {
    const out = await toEnglish(state.built, CFG.lang);
    state.english = out;
    state.englishOf = state.built;
    plain.textContent = out;
    ae('to_english', { kind: state.kind, ok: 1 });
  } catch (e) {
    plain.textContent = T.en_failed || '';
    ae('to_english', { kind: state.kind, ok: 0, err: String((e && e.message) || e).slice(0, 60) });
  } finally { plain.classList.remove('is-busy'); }
}

/** Что человек СЕЙЧАС видит — то и копируется, и то и уходит в лейны. */
const visibleText = () => (state.view === 'en' && state.english ? state.english : state.built);

/* ── Холст ───────────────────────────────────────────────────────────────── */
/**
 * Текст промта, в котором каждая смысловая часть — кнопка. Заполненная
 * читается как обычный текст и подчёркнута пунктиром; недостающая стоит на
 * СВОЁМ месте в порядке сборки как «+ Свет».
 *
 * Недостающие части, которые словарь нашёл ВНУТРИ вставленного текста, не
 * рисуются: они есть, просто не в своём слоте, и предлагать добавить их второй
 * раз значит спорить с прибором справа, который их уже засчитал.
 */
function renderCanvas(report, next) {
  const canvas = $('pg-canvas');
  if (!canvas) return;
  canvas.textContent = '';
  const order = ORDER[state.kind] || ORDER.text;
  // Части показываем С НАЗВАНИЯМИ у ВСЕХ видов, а не только у текста и кода.
  //
  // Раньше медиа-виды рисовались сплошной строкой через запятую — то есть тем
  // же абзацем, что и вид «Текст», и человек видел разницу только в шрифте
  // (NE_NAGIEV, 24.08: «меняется только шрифт промта и всё»). Два вида имеют
  // смысл, когда отличаются по СУТИ: «Текст» — то, что уедет модели, «По
  // частям» — из чего это собрано и что можно поправить.
  //
  // Скопированный промт от этого не меняется: `visibleText()` берёт
  // `state.built`, а не разметку холста.
  const blocks = true;
  const negKey = state.kind === 'image' ? 'negative' : (state.kind === 'music' ? 'exclude' : null);
  const flagged = ((CFG.targets[targetOf(state.kind)] || {}).flag_syntax || []).includes(state.model);

  let printed = 0;
  order.forEach((key) => {
    const val = (state.values[key] || '').replace(/\s+/g, ' ').trim();
    const w = report.slots[key] ? report.slots[key].w : 0;
    const line = blocks ? el('div', 'pg-line') : null;
    const host = blocks ? line : canvas;

    if (val) {
      // Разделитель рисуем ДО части, а не после: иначе последняя тащит висячую
      // запятую, и скопированный промт кривой.
      if (!blocks && printed) host.appendChild(el('span', 'pg-sep', ', '));
      if (blocks && key !== 'role') host.appendChild(el('span', 'pg-lbl', slotLabel(key) + ': '));
      const seg = el('button', 'pg-seg', prefixFor(key, val, negKey, flagged));
      seg.type = 'button';
      seg.dataset.slot = key;
      seg.title = slotLabel(key);
      if (state.editing === key) seg.classList.add('is-editing');
      seg.addEventListener('click', () => openEditor(key));
      host.appendChild(seg);
      printed++;
    } else if (!(report.slots[key] && report.slots[key].present)) {
      if (!blocks && printed) host.appendChild(el('span', 'pg-sep', ' '));
      const add = el('button', 'pg-add', '+ ' + slotLabel(key));
      add.type = 'button';
      add.dataset.slot = key;
      add.title = fill(T.weight_hint, { n: w });
      // Подсвечена ОДНА часть — та, что важнее всех прямо сейчас. Восемь
      // одинаковых бейджей «+12» рядом не подсказывают, а шумят; ранжированный
      // список живёт в приборе справа, где он читается как чек-лист.
      if (next && next.key === key) add.classList.add('is-next');
      if (key === report.required) add.classList.add('is-req');
      if (state.editing === key) add.classList.add('is-editing');
      add.addEventListener('click', () => openEditor(key));
      host.appendChild(add);
    }
    if (blocks && line && line.childNodes.length) canvas.appendChild(line);
  });
}

/** Как часть выглядит В ТЕКСТЕ: отрицание несёт свою приставку. */
function prefixFor(key, val, negKey, flagged) {
  if (key !== negKey) return val;
  // ⚠️ Приставку НЕ ставим тому, что уже начинается с запрета: разбор
  // вставленного промта кладёт сюда куски вида «no rap section», и «без no rap
  // section» — это и мусор, и два отрицания подряд. Раньше не всплывало, потому
  // что вставленный промт целиком лежал в одной части и сюда не попадал.
  if (ALREADY_NEGATED.test(val.trim())) return val;
  return flagged ? `--no ${val}` : `${CFG.negWord || 'без'} ${val}`;
}

/* ── Редактор части ──────────────────────────────────────────────────────── */
function openEditor(key) {
  state.editing = key;
  const box = $('pg-editor');
  if (!box) return;
  box.textContent = '';
  box.hidden = false;

  const meta = slotText(key);
  const head = el('div', 'pg-ed-head');
  head.appendChild(el('span', 'pg-ed-t', slotLabel(key)));
  const close = el('button', 'pg-ed-x', '×');
  close.type = 'button';
  close.setAttribute('aria-label', T.done_btn || 'OK');
  close.addEventListener('click', () => closeEditor());
  head.appendChild(close);
  box.appendChild(head);

  const long = ['task', 'context', 'examples', 'io', 'constraints', 'subject'].includes(key);
  const input = document.createElement(long ? 'textarea' : 'input');
  input.className = 'pg-input';
  input.id = 'pg-ed-input';
  input.placeholder = meta.ph || '';
  input.value = state.values[key] || '';
  if (long) input.rows = 3; else input.type = 'text';
  input.addEventListener('input', () => { state.values[key] = input.value; refresh(true); });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !long) { e.preventDefault(); closeEditor(); }
    if (e.key === 'Escape') closeEditor();
  });
  box.appendChild(input);

  if (meta.hint) box.appendChild(el('div', 'pg-ed-hint', meta.hint));

  const chips = (CFG.chips || {})[key] || [];
  if (chips.length) {
    const row = el('div', 'pg-ed-chips');
    // Подпись фишки — на языке человека, ЗНАЧЕНИЕ у картинки/видео/музыки —
    // английское (список той же формы из английской локали, спарено по
    // индексу; сторож — PromptLabChipPairingTest). Промт для этих моделей
    // обязан быть английским, а вид «English» есть у 0.4% посетителей (проба
    // Translator API: available 1 из 244); до 06.09 фишка вставляла «рок»,
    // и Suno получал русский стиль, который замеренно не выполняет.
    const enChips = (CFG.chipValues || {})[key] || [];
    const paired = isMedia(state.kind) && enChips.length === chips.length;
    const valueOf = (i) => (paired ? enChips[i] : chips[i]);
    // Фишка может нести запятые внутри («intro, verse, chorus…») — проверяем
    // вхождение целиком, а не по кускам между запятыми.
    const has = (v) => (state.values[key] || '').includes(v);
    const without = (v) => (state.values[key] || '').split(v).join('')
      .replace(/\s*,\s*,\s*/g, ', ').replace(/^\s*,\s*|\s*,\s*$/g, '').replace(/\s+/g, ' ').trim();
    chips.forEach((c, i) => {
      const v = valueOf(i);
      const b = el('button', 'pg-chip', c);
      b.type = 'button';
      if (paired && v !== c) b.title = v;
      if (has(v)) b.classList.add('is-on');
      b.addEventListener('click', () => {
        const on = has(v);
        const cur = on ? without(v) : (state.values[key] || '').trim();
        state.values[key] = on ? cur : (cur ? cur + ', ' + v : v);
        input.value = state.values[key];
        b.classList.toggle('is-on', !on);
        refresh(true);
        ae('chip', { slot: key, en: paired ? 1 : 0 });
      });
      row.appendChild(b);
    });
    box.appendChild(row);
  }

  const acts = el('div', 'pg-ed-acts');
  const done = el('button', 'lg-btn lg-btn-sm', T.done_btn || 'OK');
  done.type = 'button';
  done.addEventListener('click', () => closeEditor());
  acts.appendChild(done);
  if ((state.values[key] || '').trim()) {
    const drop = el('button', 'pg-linkbtn', T.seg_clear || '');
    drop.type = 'button';
    drop.addEventListener('click', () => { state.values[key] = ''; closeEditor(); });
    acts.appendChild(drop);
  }
  box.appendChild(acts);

  refresh(true);
  input.focus({ preventScroll: true });
  // Разрешено глобальным правилом: block:'nearest' — пустая операция, когда
  // элемент уже виден, и никогда не дёргает страницу под смотрящим человеком.
  box.scrollIntoView({ block: 'nearest' });
  ae('seg_open', { slot: key });
}

function closeEditor(silent) {
  state.editing = null;
  const box = $('pg-editor');
  if (box) { box.hidden = true; box.textContent = ''; }
  if (!silent) refresh();
}

/* ── Пересчёт ────────────────────────────────────────────────────────────── */
/**
 * Оценка собирается из ДВУХ источников знания, и порядок между ними важен.
 *
 * Про слот, который человек заполнил сам, мы знаем точно — тут словарь не
 * нужен и вреден: он однажды не засчитал заполненную «Роль» и засчитал ПУСТОЙ
 * «Контекст» из слова «нашего» в задаче. Про вставленный чужой промт мы не
 * знаем ничего, и словарь — единственное, что есть; это и делала бывшая
 * вкладка «Разбор». Поэтому: точное знание везде, где оно есть, словарь —
 * только в дырах, и только когда промт пришёл готовым.
 */
function buildReport() {
  const r = analyzeValues(state.values, state.kind, state.built);
  if (!state.foreign) return r;

  const d = analyze(state.built, state.kind);
  let score = 0;
  Object.keys(r.slots).forEach((k) => {
    if (!r.slots[k].present && d.slots[k] && d.slots[k].present) r.slots[k].present = true;
    if (r.slots[k].present) score += r.slots[k].w;
  });
  score -= Math.min(15, r.vague.length * 3);
  // `capped` пересчитываем вместе со всем остальным: слот мог стать
  // «присутствующим» по словарю, и оставленное прежним поле противоречило бы
  // соседнему `slots[required].present` — читателю пришлось бы гадать, какое
  // из двух правда.
  r.capped = !r.slots[r.required].present;
  if (r.capped) score = Math.min(score, 40);
  if (r.chars < 25) score = Math.min(score, 35);
  r.score = Math.max(0, Math.min(100, Math.round(score)));
  r.missing = Object.keys(r.slots)
    .filter((k) => !r.slots[k].present)
    .sort((a, b) => r.slots[b].w - r.slots[a].w);
  return r;
}

/** @param {boolean} keepEditor мы печатаем внутри редактора — не трогать его */
function refresh(keepEditor) {
  const flagged = ((CFG.targets[targetOf(state.kind)] || {}).flag_syntax || []).includes(state.model);
  const opts = {
    kind: state.kind,
    values: state.values,
    labels: CFG.slotLabels || {},
    flagSyntax: flagged,
    negWord: CFG.negWord || 'без',
    sections: CFG.sections || {},
  };
  state.built = buildPrompt(opts);
  state.music = state.kind === 'music' ? buildMusicPrompt(opts) : { style: '', lyrics: '' };

  const report = buildReport();
  const next = nextBestSlot(report);
  renderCanvas(report, next);
  paintMeter(report);
  renderPicks();
  renderViews();

  const chars = $('pg-chars');
  if (chars) {
    // У музыки считается СТИЛЬ против потолка поля цели (Suno — 1000): именно
    // он обрезается молча, а текст песни живёт в другом поле со своим лимитом.
    const cap = state.kind === 'music' ? ((CFG.styleMax || {})[state.model] || 0) : 0;
    chars.textContent = cap
      ? fill(T.style_cap || ':n / :max', { n: state.music.style.length, max: cap })
      : fill(T.chars_n, { n: state.built.length });
    chars.classList.toggle('is-over', !!cap && state.music.style.length > cap);
  }

  const copy = $('pg-copy');
  if (copy) copy.disabled = !state.built;
  paintLaneButtons();
  paintHandoff();
  if (!keepEditor && state.view !== 'parts') renderViews();
  return report;
}

/* ── Прибор ──────────────────────────────────────────────────────────────── */
/**
 * Кольцо, словесная оценка и РАНЖИРОВАННЫЙ список того, что добавить. Это и
 * есть бывшая вкладка «Разбор промта», ставшая показанием: она всегда на
 * экране и всегда про тот промт, который перед глазами. Отдельная строка
 * «сильнее всего добавит X» из-под холста убрана — она повторяла и этот
 * список, и подсвеченную часть в самом холсте, то есть говорила одно и то же
 * в трёх местах сразу.
 */
function paintMeter(r) {
  const meter = $('pg-meter');
  if (meter) meter.hidden = !state.started;
  if (!state.started) return;

  const g = grade(r.score);
  const ring = $('pg-ring');
  if (ring) { ring.style.setProperty('--pg-score', String(r.score)); ring.dataset.grade = g; }
  const num = $('pg-score-n');
  if (num) num.textContent = String(r.score);
  const gr = $('pg-grade');
  if (gr) gr.textContent = T['grade_' + g] || g;

  const list = $('pg-missing');
  const title = $('pg-missing-t');
  if (list) {
    list.textContent = '';
    if (!r.missing.length) {
      if (title) title.hidden = true;
      list.appendChild(el('div', 'pg-add-done', T.missing_none));
    } else {
      if (title) title.hidden = false;
      // Три строки, а не восемь: список из восьми не читают, читают первые
      // три. Обязательная часть идёт первой, каким бы ни был её вес.
      const ranked = r.missing.slice();
      if (ranked.includes(r.required)) {
        ranked.splice(ranked.indexOf(r.required), 1);
        ranked.unshift(r.required);
      }
      ranked.slice(0, 3).forEach((k) => {
        const row = el('button', 'pg-add-row');
        row.type = 'button';
        if (k === r.required) row.classList.add('is-req');
        row.appendChild(el('span', null, '+ ' + slotLabel(k)));
        row.appendChild(el('span', 'pg-add-w', '+' + r.slots[k].w));
        row.title = k === r.required ? fill(T.next_required, { slot: slotLabel(k) }) : fill(T.weight_hint, { n: r.slots[k].w });
        row.addEventListener('click', () => openEditor(k));
        list.appendChild(row);
      });
    }
  }

  const vg = $('pg-vague');
  if (vg) {
    vg.textContent = '';
    vg.hidden = !r.vague.length;
    if (r.vague.length) {
      vg.appendChild(el('div', 'pg-vague-t', T.vague_title));
      const row = el('div', 'pg-vague-row');
      r.vague.forEach((w) => row.appendChild(el('span', 'pg-vague-w', w)));
      vg.appendChild(row);
      vg.appendChild(el('div', 'pg-vague-h', T.vague_hint));
    }
  }
}

/**
 * Похожие готовые — в приборе, рядом с промтом, над которым идёт работа.
 * Только в верстаке: до первого промта библиотека стоит прямо под полем, и
 * «Популярное» справа было бы её копией с другим заголовком. Совпадение
 * считаем пересечением слов — без сети и без модели: библиотека уже
 * загружена, вид промта известен.
 */
function renderPicks() {
  const box = $('pg-picks');
  if (!box || !LIB) return;
  const lang = langOf();
  let items = [];

  if (state.started) {
    const own = (state.values[CFG.required[state.kind]] || '').toLowerCase();
    const words = own.split(/[^\p{L}\p{N}]+/u).filter((w) => w.length > 3);
    items = LIB.items
      .filter((i) => i.kind === state.kind)
      .map((i) => {
        const hay = [(i.t[lang] || i.t.en), (i.d[lang] || i.d.en), i.occ || ''].join(' ').toLowerCase();
        return { i, n: words.reduce((a, w) => a + (hay.includes(w.slice(0, 5)) ? 1 : 0), 0) };
      })
      .filter((x) => x.n > 0)
      .sort((a, b) => b.n - a.n)
      .slice(0, 3)
      .map((x) => x.i);
  }

  box.textContent = '';
  box.hidden = !items.length;
  if (!items.length) return;
  // Двоеточие уместно у строчной подписи перед фишками, но эта же строка стала
  // ЗАГОЛОВКОМ карточки и рисуется капителью — «ПОХОЖИЕ ГОТОВЫЕ:» с висячим
  // двоеточием читается как оборванная фраза.
  box.appendChild(el('div', 'pg-picks-t', String(T.related_label || '').replace(/\s*[:：]\s*$/, '')));
  const list = el('div', 'pg-picks-list');
  items.forEach((i) => {
    const b = el('button', 'pg-pick-row', i.t[lang] || i.t.en);
    b.type = 'button';
    b.addEventListener('click', () => {
      openWorkbench(i.kind, { [CFG.required[i.kind]]: bodyOf(i, lang) }, false, true);
      ae('pick_open', { id: i.id, from: 'related' });
    });
    list.appendChild(b);
  });
  box.appendChild(list);
  const all = el('button', 'pg-linkbtn pg-picks-all', T.picks_all);
  all.type = 'button';
  // Библиотека стоит ниже на этой же странице. block:'nearest' — разрешённая
  // форма: пустая операция, когда она и так на экране.
  all.addEventListener('click', () => { const lib = $('pg-lib'); if (lib) lib.scrollIntoView({ block: 'nearest' }); });
  box.appendChild(all);
}

/* ── Библиотека ──────────────────────────────────────────────────────────── */
/*
 * На странице, не в ящике. Фильтр — тип промта сверху (одна ось с
 * конструктором) плюс рубрики внутри типа, где их больше одной. Поиск — само
 * поле «Что нужно получить?»: набранная фраза подбирает карточки ниже ещё до
 * «Собрать» (совпадение по началам слов, без сети). Совпадений нет — список
 * НЕ пустеет: человек, может быть, пишет то, чего в библиотеке нет, и это
 * нормально; пустая сетка наказывала бы за это.
 *
 * Свёрнутая карточка — только смысл (рубрика, название, зачем, какие поля).
 * Тело промта раскрывается на месте: карточка занимает ряд целиком, соседи
 * уплотняются (grid-auto-flow:dense). Раскрыта одна — иначе снова стены
 * текста.
 */
const LIB_PAGE = 12;
let LIB = null;
let libKind = '';       // '' = все типы
let libCat = '';        // '' = все рубрики внутри типа
let libQuery = '';      // фраза из поля ввода
let libOpen = null;     // id раскрытой карточки
let libLimit = LIB_PAGE;

async function loadLibrary() {
  if (LIB) return LIB;
  LIB = await (await fetch(CFG.libUrl, { credentials: 'omit' })).json();
  renderLibrary();
  renderPicks();
  return LIB;
}

const langOf = () => (CFG.lang === 'ru' ? 'ru' : 'en');
const bodyOf = (item, lang) => (typeof item.body === 'string' ? item.body : (item.body[lang] || item.body.en));
const catOf = (id) => ((LIB && LIB.cats) || []).find((c) => c.id === id) || null;

/** Слова запроса → начала слов; короче трёх букв не считаем — это предлоги. */
const queryWords = (q) => String(q || '').toLowerCase().split(/[^\p{L}\p{N}]+/u)
  .filter((w) => w.length >= 3).map((w) => w.slice(0, 4));

/** Сколько слов запроса нашлось в карточке. Тело не смотрим: оно английское. */
function libMatch(item, words, lang) {
  const hay = [(item.t[lang] || item.t.en), (item.d[lang] || item.d.en), item.occ || '', (T.cat || {})[item.cat] || '']
    .join(' ').toLowerCase();
  return words.reduce((a, w) => a + (hay.includes(w) ? 1 : 0), 0);
}

function libItems() {
  if (!LIB) return { items: [], searched: false };
  const lang = langOf();
  let items = LIB.items.filter((i) => (!libKind || i.kind === libKind) && (!libCat || i.cat === libCat));
  const words = queryWords(libQuery);
  if (words.length) {
    const hit = items.map((i) => ({ i, n: libMatch(i, words, lang) })).filter((x) => x.n > 0).sort((a, b) => b.n - a.n);
    if (hit.length) return { items: hit.map((x) => x.i), searched: true };
  }
  // Промт дня — первым, когда список не отфильтрован: у всех в один день один.
  const day = dailyItem(LIB);
  if (!libKind && !libCat && day) items = [day].concat(items.filter((i) => i !== day));
  return { items, searched: false };
}

function renderCats() {
  const box = $('pg-lib-cats');
  if (!box || !LIB) return;
  // Рубрики показываем только внутри типа, где их больше одной (картинка:
  // фото/дизайн; текст: общение/работа/учёба). При «Все» второй ряд фишек
  // повторял бы ряд типов сверху — одна ось дважды.
  const cats = libKind ? LIB.cats.filter((c) => c.kind === libKind) : [];
  box.textContent = '';
  box.hidden = cats.length < 2;
  if (box.hidden) { libCat = ''; return; }
  if (libCat && !cats.some((c) => c.id === libCat)) libCat = '';
  const mk = (id, label) => {
    const b = el('button', 'pg-chip' + (libCat === id ? ' is-on' : ''), label);
    b.type = 'button';
    b.setAttribute('aria-pressed', libCat === id ? 'true' : 'false');
    b.addEventListener('click', () => {
      libCat = id; libLimit = LIB_PAGE; libOpen = null;
      renderLibrary();
      ae('lib_filter', { cat: id || 'all' });
    });
    box.appendChild(b);
  };
  mk('', T.lib_all || '');
  cats.forEach((c) => mk(c.id, (c.icon ? c.icon + ' ' : '') + ((T.cat || {})[c.id] || c.id)));
}

function renderLibrary() {
  const grid = $('pg-lib-grid');
  if (!grid || !LIB) return;
  renderCats();
  const { items, searched } = libItems();
  const lang = langOf();
  const day = dailyItem(LIB);
  // Найденное по фразе показываем целиком: это ответ на вопрос, а не каталог.
  const shown = searched ? items : items.slice(0, libLimit);

  grid.textContent = '';
  shown.forEach((i) => grid.appendChild(libCard(i, lang, i === day)));

  const none = $('pg-lib-none');
  if (none) none.hidden = items.length > 0;
  const n = $('pg-lib-n');
  if (n) n.textContent = items.length ? String(items.length) : '';
  const more = $('pg-lib-more');
  if (more) {
    const rest = items.length - shown.length;
    more.hidden = rest <= 0;
    more.textContent = fill(T.lib_more, { n: rest });
  }
}

function initLibrary() {
  const more = $('pg-lib-more');
  if (more) more.addEventListener('click', () => { libLimit += LIB_PAGE * 2; renderLibrary(); ae('lib_more', {}); });

  // Поле «Что нужно получить?» — оно же поиск по библиотеке. Отдельной
  // строки поиска нет: два поля для одного и того же — та же болезнь копий.
  const seed = $('pg-seed');
  if (seed) {
    let t = 0;
    seed.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const v = seed.value.trim();
        // Вставленный целиком промт — не запрос к библиотеке.
        const q = v.length >= 3 && v.length <= 80 ? v : '';
        if (q === libQuery) return;
        libQuery = q; libLimit = LIB_PAGE; libOpen = null;
        renderLibrary();
        if (q) ae('lib_search', { hit: libItems().searched ? 1 : 0 });
      }, 120);
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && libOpen) { libOpen = null; renderLibrary(); }
  });
}

/** Подпись поля переменной на языке читателя; нет карты — показываем имя. */
function varLabel(name, lang) {
  const map = (LIB && LIB.vars && LIB.vars[name]) || null;
  return (map && (map[lang] || map.en)) || name;
}

/**
 * Тело промта с переменными как МЕТКАМИ в тексте: видно, куда встанет
 * введённое, и оно встаёт туда на глазах. Копируется при этом `fillVars`:
 * незаполненная переменная остаётся в тексте видимой — человек видит, что
 * забыл, вместо промта с дырой.
 */
function paintBody(box, body, filled, lang) {
  box.textContent = '';
  const re = /\{\{([\p{L}\p{N}_-]+)\}\}/gu;
  let last = 0; let m;
  while ((m = re.exec(body)) !== null) {
    if (m.index > last) box.appendChild(document.createTextNode(body.slice(last, m.index)));
    const v = (filled[m[1]] || '').trim();
    const mark = el('mark', 'pg-var' + (v ? ' is-filled' : ''), v || varLabel(m[1], lang));
    mark.dataset.name = m[1];
    mark.title = varLabel(m[1], lang);
    box.appendChild(mark);
    last = m.index + m[0].length;
  }
  if (last < body.length) box.appendChild(document.createTextNode(body.slice(last)));
}

function libCard(item, lang, isDaily) {
  const card = el('article', 'pg-libcard');
  card.dataset.id = item.id;
  card.dataset.kind = item.kind;
  if (isDaily) card.classList.add('is-daily');
  const open = libOpen === item.id;
  if (open) card.classList.add('is-open');

  const body = bodyOf(item, lang);
  const vars = varsOf(body);
  const cat = catOf(item.cat);

  // Шапка — кнопка. Внутри только span'ы: заголовочные теги в кнопке
  // недопустимы, блочность задаёт CSS.
  const sum = el('button', 'pg-libcard-sum');
  sum.type = 'button';
  sum.setAttribute('aria-expanded', open ? 'true' : 'false');
  // Превью — результат промта, не текст. Есть не у всех: img2img-промты
  // (реставрация, раскраска) намеренно без него — text2img показал бы
  // исходник, а не результат.
  const shot = (cls) => {
    const im = el('img', cls);
    im.src = (CFG.libBase || '') + item.img;
    im.alt = '';
    im.loading = 'lazy';
    im.decoding = 'async';
    im.width = 640; im.height = 480;
    return im;
  };
  if (item.img) sum.appendChild(shot('pg-libcard-img'));
  const top = el('span', 'pg-libcard-top');
  top.appendChild(el('span', 'pg-libcard-cat', ((cat && cat.icon) ? cat.icon + ' ' : '') + ((T.cat || {})[item.cat] || item.cat)));
  if (isDaily) top.appendChild(el('span', 'pg-libcard-day', T.daily_title || ''));
  sum.appendChild(top);
  sum.appendChild(el('span', 'pg-libcard-t', item.t[lang] || item.t.en));
  sum.appendChild(el('span', 'pg-libcard-d', item.d[lang] || item.d.en));
  const foot = el('span', 'pg-libcard-foot');
  // Имя переменной внутри промта и ПОДПИСЬ поля — разные вещи. У одноязычных
  // (английских) тел имена английские: незаполненная переменная остаётся
  // видимой и уезжает в модель, а `{{кто}}` посреди английской строки —
  // кириллица в чужом промте. Подпись при этом на языке читателя.
  vars.forEach((v) => foot.appendChild(el('span', 'pg-libcard-tag', varLabel(v, lang))));
  foot.appendChild(el('span', 'pg-libcard-arrow', '›'));
  sum.appendChild(foot);
  sum.addEventListener('click', () => {
    libOpen = open ? null : item.id;
    renderLibrary();
    if (!open) ae('lib_expand', { id: item.id });
  });
  card.appendChild(sum);
  if (!open) return card;

  const filled = {};
  const wrap = el('div', 'pg-libcard-body' + (vars.length || item.img ? ' has-side' : ''));
  const pre = el('div', 'pg-libcard-b');
  pre.dir = 'auto';
  paintBody(pre, body, filled, lang);

  if (vars.length || item.img) {
    const vw = el('div', 'pg-libcard-vars');
    if (item.img) vw.appendChild(shot('pg-libcard-shot'));
    if (vars.length) vw.appendChild(el('span', 'pg-libcard-vl', T.lib_vars));
    vars.forEach((v) => {
      const inp = el('input', 'pg-input');
      inp.type = 'text';
      inp.placeholder = varLabel(v, lang);
      inp.setAttribute('aria-label', varLabel(v, lang));
      inp.addEventListener('input', () => { filled[v] = inp.value; paintBody(pre, body, filled, lang); });
      vw.appendChild(inp);
    });
    wrap.appendChild(vw);
  }
  wrap.appendChild(pre);

  const acts = el('div', 'pg-libcard-acts');
  const text = () => fillVars(body, filled);
  const copy = el('button', 'lg-btn lg-btn-sm pg-libcard-copy', T.lib_copy);
  copy.type = 'button';
  copy.addEventListener('click', () => { copyText(text()); histAdd(text(), item.kind); ae('lib_copy', { id: item.id }); });
  acts.appendChild(copy);
  const use = el('button', 'lg-btn lg-btn-ghost lg-btn-sm pg-libcard-open', T.lib_open);
  use.type = 'button';
  use.addEventListener('click', () => {
    openWorkbench(item.kind, { [CFG.required[item.kind]]: text() }, false, true);
    // Верстак стоит ВЫШЕ библиотеки: без этого выбранный промт попадает туда,
    // куда человек не смотрит. block:'nearest' — разрешённая форма: пустая
    // операция, когда верстак и так на экране.
    const work = $('pg-work');
    if (work) work.scrollIntoView({ block: 'nearest' });
    ae('lib_adopt', { id: item.id });
  });
  acts.appendChild(use);
  wrap.appendChild(acts);
  card.appendChild(wrap);
  return card;
}

/**
 * «Промт дня» — 21 678 запросов в месяц по замеру, и никто не отдаёт это
 * отдельной сущностью. Выбор ДЕТЕРМИНИРОВАННЫЙ по дате: у всех посетителей в
 * один день один промт, иначе это не «промт дня», а случайная карточка.
 */
function dailyItem(lib) {
  const d = new Date();
  const dayNo = Math.floor(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) / 86400000);
  return lib.items[dayNo % lib.items.length];
}

/* ── Копирование и история ───────────────────────────────────────────────── */
function copyText(text) {
  if (!text) return;
  const done = () => { if (window.__toast) window.__toast(T.copied, 'success'); };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(done).catch(() => fallbackCopy(text, done));
  } else fallbackCopy(text, done);
}

function fallbackCopy(text, done) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.cssText = 'position:fixed;left:-9999px';
  document.body.appendChild(ta);
  ta.select();
  try { document.execCommand('copy'); done(); } catch { /* ничего не поделать */ }
  ta.remove();
}

const HIST_KEY = 'timbrica:prompt-lab:history';
const histLoad = () => { try { return JSON.parse(localStorage.getItem(HIST_KEY) || '[]'); } catch { return []; } };
const histSave = (l) => { try { localStorage.setItem(HIST_KEY, JSON.stringify(l.slice(0, 20))); } catch { /* приватный режим */ } };

function histAdd(text, kind) {
  if (!text) return;
  const list = histLoad().filter((x) => x.t !== text);
  list.unshift({ t: text, k: kind || state.kind, at: Date.now() });
  histSave(list);
  renderHistory();
}

function renderHistory() {
  const wrap = $('pg-hist');
  if (!wrap) return;
  const list = histLoad();
  const box = $('pg-hist-box');
  if (box) box.hidden = list.length === 0;
  wrap.textContent = '';
  if (!list.length) return;
  list.forEach((h) => {
    const row = el('div', 'pg-hist-row');
    const b = el('button', 'pg-hist-open', h.t.slice(0, 110) + (h.t.length > 110 ? '…' : ''));
    b.type = 'button';
    b.title = T.hist_restore;
    b.addEventListener('click', () => openWorkbench(h.k || 'text', { [CFG.required[h.k || 'text']]: h.t }, false, true));
    row.appendChild(b);
    const c = el('button', 'pg-hist-copy', '⧉');
    c.type = 'button';
    c.setAttribute('aria-label', T.copy_btn);
    c.addEventListener('click', () => copyText(h.t));
    row.appendChild(c);
    wrap.appendChild(row);
  });
}

/* ── Лейны: браузерная модель и облачная ─────────────────────────────────── */
/**
 * Один и тот же лейн («улучшить», «проверить») может идти двумя дорогами.
 * Разница для человека — в цене, поэтому она написана НА КНОПКЕ, а не в сноске
 * под ней: «Улучшить · в браузере» против «Улучшить · 60 ток.».
 *
 * ⛔ Молчаливого отката с браузерной модели на облачную нет и быть не может:
 * это списало бы токены за нажатие, которое обещало обойтись без них. Сломался
 * браузерный путь — говорим об этом и переводим кнопку в облачный режим, где
 * цена снова написана до нажатия.
 */
const deviceReady = () => !device.broken && (device.model === 'available' || device.model === 'downloadable')
  && (device.lang === 'available' || device.lang === 'downloadable');
const cloudReady = () => !!CFG.cloud;
const laneOf = () => (deviceReady() ? 'device' : (cloudReady() ? 'cloud' : 'none'));
/**
 * Облачный лейн — только для вошедших, и это второй замок на той же двери.
 * Замер 24–26.08: run_click 9 → run_failed 9, improve_failed 4 — все 401.
 * Гость жал кнопку с ценой и получал «войдите» ПОСЛЕ нажатия: 16 нажатий,
 * 0 успехов. Кнопка обязана называть замок до нажатия, а нажатие гостя —
 * не ходить на сервер за отказом, который известен заранее.
 */
const guestOnCloud = () => laneOf() === 'cloud' && !CFG.auth;
/** Баланс в сноске обязан быть тем, что осталось ПОСЛЕ списания. */
function syncBalance(meta) {
  if (meta && typeof meta.balance === 'number') { CFG.balance = meta.balance; paintLaneButtons(); }
}
function guestGate(op) {
  if (!guestOnCloud()) return false;
  showHint(fill(T.need_login, { url: CFG.loginUrl }));
  ae('guest_gate', { op });
  return true;
}

async function probeDevice() {
  let p = { state: 'absent', lang: 'absent', present: false };
  try { p = await probeModel(CFG.lang); } catch { /* проба не ломает тул */ }
  device.model = p.state;
  device.lang = p.lang;
  try { device.translator = await probeTranslator(CFG.lang); } catch { device.translator = 'unavailable'; }

  // ⚠️ Телеметрия исхода пробы — с ПЕРВОГО дня. Модель ставится не у всех
  // (нужно место на диске и поддержанная ОС), и без этой строки мы месяц не
  // узнаем, какой доле посетителей показываем кнопку, которая не сработает.
  ae('ondevice_probe', { model: device.model, lang: device.lang, tr: device.translator });

  paintLaneButtons();
  renderViews();
  renderModelNote();
}

function paintLaneButtons() {
  const lane = laneOf();
  const imp = $('pg-improve');
  const run = $('pg-run');
  const note = $('pg-lane-note');
  const ready = state.built && state.built.length >= (CFG.minChars || 3);

  [imp, run].forEach((b) => { if (b) { b.hidden = lane === 'none'; b.disabled = state.busy || !ready; } });
  const ab = $('pg-ab');
  if (ab) ab.hidden = lane === 'none';

  document.querySelectorAll('.pg-price').forEach((sp) => {
    const key = sp.dataset.price;
    if (lane === 'device') {
      sp.textContent = T.od_here || '';
      sp.dataset.free = '1';
    } else if (lane === 'cloud') {
      const n = key === 'ab' ? (CFG.costs.run * 2 + CFG.costs.improve) : (CFG.costs[key] || 0);
      // Цена И замок — оба до нажатия: «60 ток. · нужен вход».
      sp.textContent = fill(T.cost_tokens, { n }) + (CFG.auth ? '' : ' · ' + (T.lane_login || ''));
      sp.dataset.free = '0';
      sp.dataset.lock = CFG.auth ? '' : 'login';
    } else { sp.textContent = ''; }
  });

  if (note) {
    let txt = '';
    if (lane === 'device') {
      txt = device.model === 'downloadable' ? (T.od_download || '') : (T.od_free || '');
    } else if (lane === 'cloud') {
      txt = T.od_cloud_note || '';
      // Баланс — рядом с ценой, чтобы «хватит ли» решалось до нажатия.
      if (CFG.auth && typeof CFG.balance === 'number') txt += ' ' + fill(T.balance_line, { n: CFG.balance });
    }
    note.textContent = txt;
    note.hidden = !txt;
  }
}

/**
 * «Сгенерировать песню» — своя дверь для музыки: промт не описывается словами
 * чат-модели, а исполняется нашим же /song-generator. Стиль и каркас текста
 * уезжают sessionStorage-мостом (как «песня → /audio-to-video»), там их
 * подхватывает applyPromptHandoff(). Ключ `handoff` в config/prompt-lab.php
 * объявлен с 21.08, но до 06.09 его не читала ни одна строка.
 */
function paintHandoff() {
  const b = $('pg-handoff');
  if (!b) return;
  const on = state.kind === 'music' && !!CFG.handoffUrl && !!state.music.style;
  b.hidden = !on;
  b.disabled = state.busy;
}

function goHandoff() {
  if (!CFG.handoffUrl || !state.music.style) return;
  try {
    sessionStorage.setItem('__handoff_prompt_to_song_v1', JSON.stringify({
      style: state.music.style,
      lyrics: state.music.lyrics,
      ts: Date.now(),
    }));
  } catch { /* приватный режим — уедем без моста, страница откроется пустой */ }
  histAdd(state.built, state.kind);
  ae('handoff_song', { style: state.music.style.length, lyrics: state.music.lyrics.length, model: state.model });
  location.href = CFG.handoffUrl;
}

function setBusy(on) {
  state.busy = on;
  paintLaneButtons();
  paintHandoff();
  if (on) showHint(T.busy || '');
}

function showHint(html) {
  const h = $('pg-hint');
  if (h) h.innerHTML = html;
}

/* ── Облачный транспорт ──────────────────────────────────────────────────── */
/** Один потребитель для живого SSE и запасного JSON — как у /paraphraser. */
async function callCloud(op, prompt, onDelta) {
  const payload = { prompt, target: targetOf(state.kind), model: state.model, lang: CFG.lang };
  const headers = { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': CFG.csrf, 'X-Requested-With': 'XMLHttpRequest' };

  if (CFG.stream) {
    const resp = await fetch(CFG.streamUrl.replace('__OP__', op), { method: 'POST', headers, body: JSON.stringify(payload) });
    if (!resp.ok || !resp.body) {
      throw Object.assign(new Error('gate'), { status: resp.status, data: await resp.json().catch(() => ({})) });
    }
    const reader = resp.body.getReader();
    const dec = new TextDecoder();
    let buf = ''; let out = ''; let meta = {};
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += dec.decode(value, { stream: true });
      let idx;
      while ((idx = buf.indexOf('\n\n')) !== -1) {
        const frame = buf.slice(0, idx);
        buf = buf.slice(idx + 2);
        const ev = (frame.match(/^event:\s*(.+)$/m) || [])[1];
        const dl = (frame.match(/^data:\s*(.+)$/m) || [])[1];
        if (!ev || !dl) continue;
        let d = {};
        try { d = JSON.parse(dl); } catch { continue; }
        if (ev === 'delta' && d.t) { out += d.t; onDelta(out); }
        else if (ev === 'done') meta = d;
        else if (ev === 'error') throw Object.assign(new Error('lane'), { status: 502, data: d });
      }
    }
    return { text: out, meta };
  }

  const resp = await fetch(CFG.jsonUrl.replace('__OP__', op), { method: 'POST', headers, body: JSON.stringify(payload) });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.ok) throw Object.assign(new Error('gate'), { status: resp.status, data });
  onDelta(data.text);
  return { text: data.text, meta: data };
}

function handleErr(e) {
  const status = e.status || 0;
  const data = e.data || {};
  if (status === 401) return showHint(fill(T.need_login, { url: CFG.loginUrl }));
  if (status === 402) {
    const tpl = CFG.buyUrl ? T.need_tokens : T.need_tokens_nobuy;
    return showHint(fill(tpl, { need: data.need || '', bal: data.balance || 0, url: CFG.buyUrl || '#' }));
  }
  if (status === 429) return showHint(T.err_throttled || '');
  if (status === 503) return showHint(T.err_disabled || '');
  if (status === 422) return showHint(data.msg || T.err_input || '');
  return showHint(T.err_failed || '');
}

/**
 * Браузерный путь сломался уже ПОСЛЕ нажатия. Молча уехать в облако нельзя —
 * человек нажимал на кнопку без цены. Показываем, что случилось, и переводим
 * кнопки в облачный режим: следующая попытка снова будет с ценой на виду.
 */
function deviceFailed(e) {
  device.broken = true;
  paintLaneButtons();
  showHint(cloudReady() ? (T.od_failed || '') : (T.err_failed || ''));
  ae('ondevice_failed', { err: String((e && e.message) || e).slice(0, 60) });
}

/* ── Улучшение ───────────────────────────────────────────────────────────── */
async function doImprove() {
  const prompt = visibleText().trim();
  if (!prompt) return;
  const lane = laneOf();
  if (lane === 'none' || guestGate('improve')) return;

  setBusy(true);
  const pane = $('pg-out');
  const box = $('pg-out-improved');
  if (pane) pane.hidden = false;
  if (box) box.hidden = false;
  const target = $('pg-improved');
  if (target) target.textContent = '';
  const scoreBox = $('pg-improved-score');
  if (scoreBox) scoreBox.hidden = true;
  ae('improve_click', { kind: state.kind, chars: prompt.length, lane });

  try {
    let text = '';
    if (lane === 'device') {
      text = await improveOnDevice(prompt, state.kind, CFG.lang, {
        onDelta: (p) => { if (target) target.textContent = p; },
        onProgress: () => showHint(T.od_downloading || ''),
      });
      showHint('');
    } else {
      const r = await callCloud('improve', prompt, (p) => { if (target) target.textContent = p; });
      text = r.text;
      showHint(fill(T.spent, { n: r.meta.cost_tokens || '', b: r.meta.balance != null ? r.meta.balance : '' }));
      syncBalance(r.meta);
    }

    if (!text) throw new Error('empty');
    state.improved = text;
    state.improvedSrc = lane;
    if (target) target.textContent = text;
    const srcBox = $('pg-improved-src');
    if (srcBox) srcBox.textContent = lane === 'device' ? (T.od_src_device || '') : (T.od_src_cloud || '');

    // Оценка усиленного той же линейкой — доказательство, а не обещание.
    if (scoreBox) {
      const before = analyze(prompt, state.kind).score;
      const after = analyze(text, state.kind).score;
      scoreBox.hidden = false;
      scoreBox.textContent = `${before} → ${after}`;
      scoreBox.dataset.up = after > before ? '1' : '0';
    }
    histAdd(text, state.kind);
    ae('improve_done', { kind: state.kind, lane });
  } catch (e) {
    if (lane === 'device') deviceFailed(e);
    else { handleErr(e); ae('improve_failed', { status: e.status || 0 }); }
  } finally { setBusy(false); }
}

/* ── Прогон ──────────────────────────────────────────────────────────────── */
async function doRun(which) {
  const prompt = which === 'improved' && state.improved ? state.improved : visibleText().trim();
  if (!prompt) return;
  const lane = laneOf();
  if (lane === 'none' || guestGate('run')) return;

  setBusy(true);
  const pane = $('pg-out');
  const grid = $('pg-ab-grid');
  if (pane) pane.hidden = false;
  if (grid) grid.hidden = false;
  const wrap = $(which === 'improved' ? 'pg-ans-after' : 'pg-ans-before');
  const box = $(which === 'improved' ? 'pg-answer-after' : 'pg-answer-before');
  if (wrap) wrap.hidden = false;
  if (box) box.textContent = '';
  ae('run_click', { kind: state.kind, which, lane });

  try {
    if (lane === 'device') {
      await runOnDevice(prompt, state.kind, CFG.lang, {
        onDelta: (p) => { if (box) box.textContent = p; },
        onProgress: () => showHint(T.od_downloading || ''),
      });
      showHint('');
    } else {
      const r = await callCloud('run', prompt, (p) => { if (box) box.textContent = p; });
      if (box) box.textContent = r.text;
      showHint(fill(T.spent, { n: r.meta.cost_tokens || '', b: r.meta.balance != null ? r.meta.balance : '' }));
      syncBalance(r.meta);
    }
    ae('run_done', { kind: state.kind, which, lane });
  } catch (e) {
    if (lane === 'device') deviceFailed(e);
    else { handleErr(e); ae('run_failed', { status: e.status || 0 }); }
  } finally { setBusy(false); }
}

/**
 * Сравнение до/после — то, чего нет ни у одного разобранного конкурента
 * («промт выдают, проверить нельзя»; у половины — «нужен свой ключ»). Кнопка
 * живёт РЯДОМ С УСИЛЕННЫМ промтом, а не в общем ряду: пока сравнивать не с чем,
 * она была четвёртой кнопкой, которая ничего не могла сделать.
 */
async function doAb() {
  if (!state.improved) return;
  await doRun('original');
  await doRun('improved');
  ae('ab_done', { kind: state.kind, lane: laneOf() });
}

function initLanes() {
  const bind = (id, fn) => { const b = $(id); if (b) b.addEventListener('click', fn); };
  bind('pg-improve', doImprove);
  bind('pg-run', () => doRun('original'));
  bind('pg-ab', doAb);
  bind('pg-copy-improved', () => copyText(state.improved));
  bind('pg-use-improved', () => {
    if (!state.improved) return;
    // Усиленный промт РАЗБИРАЕТСЯ по частям, как и вставленный: раньше он
    // целиком ложился в обязательную часть, и «По частям» показывал один
    // кусок — тот же дефект, что #5240, только входом позже.
    openWorkbench(state.kind, safeSplit(state.improved, state.kind), false, true);
  });
  bind('pg-handoff', goHandoff);
  bind('pg-copy-style', () => { copyText(state.music.style); ae('copy', { kind: state.kind, view: 'style' }); });
  bind('pg-copy-lyrics', () => { copyText(state.music.lyrics); ae('copy', { kind: state.kind, view: 'lyrics' }); });
}

/* ── Пилюля «вниз, к полю» ───────────────────────────────────────────────── */
/**
 * Порядок блоков на странице — фиксированная конвенция (интро → инструкция →
 * рабочая область), и двигать его нельзя. На телефоне это значит, что поле
 * ввода стоит ниже сгиба, и человек не находит, куда писать: замер по сайту —
 * 46% мобильных находят рабочую зону за 5 с против 75% на десктопе.
 *
 * Санкционированное лекарство — подсказка, а НЕ автопрокрутка. Ловушки те же,
 * что у общей зоны загрузки, и обе здесь учтены: показывать только на
 * касательном вводе, и уступать место 152-ФЗ баннеру согласия, у которого
 * `position:fixed` и потому ВСЕГДА null в offsetParent — видимость читается из
 * вычисленного display, а не из него.
 */
function installCue() {
  const target = $('pg-seed');
  if (!target || !('IntersectionObserver' in window)) return;
  try { if (!matchMedia('(pointer:coarse)').matches) return; } catch { return; }
  const label = T.cue_label;
  if (!label) return;

  let cue = null, outOfView = false, dead = false, mo = null;

  const consentUp = () => {
    const cc = document.querySelector('.cc-banner.cc-visible');
    if (!cc) return false;
    try { return getComputedStyle(cc).display !== 'none'; } catch { return true; }
  };
  const kill = () => {
    if (dead) return;
    dead = true;
    try { io.disconnect(); } catch { /* уже отключён */ }
    try { if (mo) mo.disconnect(); } catch { /* уже отключён */ }
    if (cue && cue.parentNode) cue.parentNode.removeChild(cue);
  };
  const show = () => {
    if (dead || cue || !outOfView) return;
    if (consentUp()) {
      if (!mo) {
        mo = new MutationObserver(() => { if (!consentUp()) { mo.disconnect(); mo = null; show(); } });
        mo.observe(document.body, { attributes: true, childList: true, subtree: true });
      }
      return;
    }
    cue = el('button', 'pg-cue');
    cue.type = 'button';
    cue.appendChild(el('span', 'pg-cue-a', '↓'));
    cue.appendChild(el('span', null, label));
    cue.addEventListener('click', () => {
      target.scrollIntoView({ block: 'nearest' });
      try { target.focus({ preventScroll: true }); } catch { /* фокус не обязателен */ }
      ae('fold_cue', { act: 'tap' });
      kill();
    });
    document.body.appendChild(cue);
    ae('fold_cue', { act: 'shown' });
  };

  const io = new IntersectionObserver((rows) => {
    outOfView = !rows[0].isIntersecting;
    if (outOfView) show(); else kill();
  }, { threshold: 0.15 });
  io.observe(target);
}

/* ── Старт ───────────────────────────────────────────────────────────────── */
function init() {
  initKindTabs();
  renderModels();
  initStart();
  initViews();
  initLanes();
  initLibrary();
  renderHistory();

  const copy = $('pg-copy');
  if (copy) copy.addEventListener('click', () => {
    const t = visibleText();
    copyText(t);
    histAdd(t, state.kind);
    ae('copy', { kind: state.kind, view: state.view });
  });
  const restartBtn = $('pg-restart');
  if (restartBtn) restartBtn.addEventListener('click', restart);
  const hclear = $('pg-hist-clear');
  if (hclear) hclear.addEventListener('click', () => { histSave([]); renderHistory(); });

  paintLaneButtons();
  loadLibrary().catch(() => { /* без библиотеки конструктор работает */ });
  probeDevice();
  installCue();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
